import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import aboutImg from "../../assets/images/about/about.png";
import useStore from "../../store/information";


const AboutPart = () => {
    const [data, setData] = useState({});
  const { totalInfo } = useStore();
    useEffect(() => {
      if (totalInfo) {
      
     
        const email = localStorage.getItem('email');
        setData({
        
          email: totalInfo.email || email ,
        });
      }
    }, [totalInfo]);
  return (
    <div className="about__area about__area_one p-relative pt---10 pb---120">
    <div className="container">
      <div className="row justify-content-center align-items-center">
        <div className="col-lg-6">
          <div className="about__image">
            <img src={aboutImg} alt="About" />
            {/* <img
              className="react__shape__ab"
              src={aboutBadge}
              alt="Shape Image"
            /> */}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="about__content">
            <h2
              className="about__title wow animate__fadeInUp"
              data-wow-duration="0.3s"
            >
              Bienvenue to <br /> <em>Your France Teachers Language School</em>
            </h2>
            <p
              className="about__paragraph wow animate__fadeInUp"
              data-wow-duration="0.5s"
            >
              At Your French Teacher, we believe learning French should feel personal, practical, and inspiring. Our mission is to make the French language accessible to everyon whether you're studying for school, preparing for travel, or simply falling in love with the sound of la langue française. We provide easy-to-follow lessons, real-life vocabulary, cultural insights, and supportive guidance through every step of your journey.
    
            <br/>Bienvenue à votre nouvelle aventure linguistique. 
            <br/>Let’s learn French, together.

            </p>
            <p
              className="about__paragraph2 wow animate__fadeInUp"
              data-wow-duration="0.7s"
            >
              {" "}
              <ul className="mb-2 about__paragraph2 wow animate__fadeInUp" data-wow-duration="0.9s">
              
              <li className="last-li">
             
                <em>Get Support</em>
                <Link to="#"> {data.email || 'info@yourfrenchteachers.com'}</Link>
              </li>
            </ul>
            </p>
            
            <h4 className="about__sub_heading">Why Choose Us?</h4>
            <p className="wow animate__fadeInUp" data-wow-duration="0.6s">
              
              Clear, beginner-friendly lessons<br />
              Real-life vocabulary & native expressions<br />
              Cultural insights, not just grammar rules<br />
              Learn at your own pace, anytime<br />
              Supportive, learner-focused approach<br />
              Practical skills for real conversations<br />
              Built with passion for French and teaching<br />
             Learn French, your way anytime, anywhere.
             
            </p>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default AboutPart;
